/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_RequiredInputs */

const en_us2_body_assessment_consent_required = /** @type {(inputs: Body_Assessment_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You haven't agreed to the photo estimate yet.`)
};

const pt_br2_body_assessment_consent_required = /** @type {(inputs: Body_Assessment_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não autorizou a estimativa por foto.`)
};

const es_419_body_assessment_consent_required = /** @type {(inputs: Body_Assessment_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no autorizaste la estimación por foto.`)
};

const pt_pt2_body_assessment_consent_required = /** @type {(inputs: Body_Assessment_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não autorizaste a estimativa por fotografia.`)
};

const fr_fr2_body_assessment_consent_required = /** @type {(inputs: Body_Assessment_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'as pas encore autorisé l'estimation par photo.`)
};

const de_de2_body_assessment_consent_required = /** @type {(inputs: Body_Assessment_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast der Schätzung per Foto noch nicht zugestimmt.`)
};

const it_it2_body_assessment_consent_required = /** @type {(inputs: Body_Assessment_Consent_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai ancora autorizzato la stima da foto.`)
};

/**
* | output |
* | --- |
* | "You haven't agreed to the photo estimate yet." |
*
* @param {Body_Assessment_Consent_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_required = /** @type {((inputs?: Body_Assessment_Consent_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_required(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_required(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_required(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_required(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_required(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_required(inputs)
	return en_us2_body_assessment_consent_required(inputs)
});
export { body_assessment_consent_required as "body_assessment.consent_required" }